import React from 'react'
import { cn, Modal, Text } from '@artprov/design-system'
import HtmlViewer from '../../../../../common/components/HtmlViewer'

export default function ModalComprobante({ closeModal, isModalOpen, adjunto }) {
    return (
        <Modal.Container
            open={isModalOpen}
            className={cn("overflow-x-hidden")}
            onClose={closeModal}
            closeOnClickOutside={false}
        >
            <Modal.Content width={489} height={677}>
                <Modal.Header>
                    <Modal.Title>Comprobante adjunto <Text variant="body1">{adjunto?.name ?? ''}</Text></Modal.Title>
                    <Modal.Close onClose={() => closeModal()} />
                </Modal.Header>
                <Modal.Body className={cn("w-full")}>
                    <HtmlViewer file={adjunto} />
                </Modal.Body>
            </Modal.Content>
        </Modal.Container>
    )
}

